<template>
  <div>
    <div class="diaContainer yauto">
      <!-- 项目结算申请新增表单 -->
      <el-form
        ref="addSettlementForm1"
        :rules="rules"
        :model="addSettlementForm"
        v-if="showForm==='showFormClearAdd1'"
        label-position="left"
        label-width="120px"
      >
        <div class="diaForm_box">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <el-form-item label="项目名称">
              <el-input
                :disabled="draftDisable"
                class="disableWithWhite"
                v-model="addSettlementForm.business_name"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addSettlementForm.member">
              <span
                v-if="addSettlementForm.member"
                style="color:#666;font-size:16px"
              >{{addSettlementForm.member.nickname}}</span>
            </el-form-item>
            <!-- <div
              style="font-size:12px;margin-left:110px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*关联项目如果描述不清晰，请在备注描述项目情况，结算金额说明等；附件请上传对应项目的现场照片、报告或其他证明文件。</div>-->
            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="$store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addSettlementForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 结算金额 -->
            <el-form-item label="结算金额">
              <el-input
                :disabled="draftDisable"
                type="number"
                placeholder="请输入结算金额"
                v-model="addSettlementForm.total"
              ></el-input>
              <div style="width:40px;text-align:center;line-height:40px;">元</div>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="备注" data-v-step2="4">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addSettlementForm.remark"
              ></el-input>
            </el-form-item>

            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:20px" data-v-step2="6">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 项目结算申请审批表单 -->
      <el-form
        ref="addSettlementForm2"
        :rules="rules"
        :model="addSettlementForm"
        v-if="showForm==='showFormClearHandle1'"
        label-position="left"
        label-width="120px"
      >
        <div class="diaForm_box diaEditFormBox">
          <div class="ShowFormBtn">
            <el-button
              v-if="addSettlementForm.withdraw_status=='1'"
              @click="handleFinnaceWithDraw('settlement',addSettlementForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >撤回</el-button>
            <el-button
              v-if="addSettlementForm.is_just=='1'"
              @click="handleFinnaceApproveWithDraw('settlement',addSettlementForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >审批撤回</el-button>
            <el-button
              @click="approveVisible=true"
              v-if="addSettlementForm.approval_status=='1'"
              class="creat"
              style="background-color:#40A0F2;"
            >去审批</el-button>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" style="margin-bottom:0px;">
              <el-input
                v-if="addSettlementForm.is_edit=='1'"
                class="disableWithWhite"
                v-model="addSettlementForm.business_name"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addSettlementForm.business_name}}</span>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addSettlementForm.member">
              <span
                v-if="addSettlementForm.member"
                style="color:#666;font-size:16px"
              >{{addSettlementForm.member.nickname}}</span>
            </el-form-item>
            <!-- <div
              style="font-size:12px;margin-left:110px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*关联项目如果描述不清晰，请在备注描述项目情况，结算金额说明等；附件请上传对应项目的现场照片、报告或其他证明文件。</div>-->

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="addSettlementForm.is_edit=='1' && $store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addSettlementForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- 结算金额 -->
            <el-form-item label="结算金额" style="margin-bottom:0px;">
              <el-input
                v-if="addSettlementForm.is_edit=='1'"
                type="number"
                class="disableWithWhite"
                v-model="addSettlementForm.total"
              ></el-input>
              <div
                v-if="addSettlementForm.is_edit=='1'"
                style="width:40px;text-align:center;line-height:40px;"
              >元</div>
              <span v-else style="color:#666;font-size:16px">{{addSettlementForm.total}}</span>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="备注">
              <el-input
                v-if="addSettlementForm.is_edit=='1'"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addSettlementForm.remark"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addSettlementForm.remark"
              ></el-input>
            </el-form-item>

            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:20px">
              <upload-file
                style="width:100%"
                :isSubmit="addSettlementForm.is_edit=='1'"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
            <!--   --  到账日期 -->

            <!-- <el-form-item label="到账日期" style="margin-bottom:20px">
              <span style="color:#666;font-size:16px">{{addSettlementForm.arrival_date}}</span>
            </el-form-item>-->
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">审批信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 已通过 -->
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in addSettlementForm.approval_log"
                :color="activity.approval_status==0?'':'#128bf1'"
                :key="index"
              >
                <div style="margin-bottom:5px">
                  <span>提交人:</span>
                  <span>{{activity.memberInfo.nickname}}</span>
                  <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                  <span>{{activity.add_time}}</span>
                </div>
                <div>
                  <span
                    v-if="activity.approval_status=='1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                  <span
                    v-if="activity.approval_status=='-1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                  <span
                    v-if="activity.approval_status=='0'"
                    v-for="item in activity.tomemberInfo"
                    style="margin-right:10px"
                  >{{item.nickname+' '}}</span>
                  <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                  <span
                    style="margin-left:10px"
                    v-if="activity.update_time"
                  >{{activity.update_time}}</span>
                </div>
                <div class="remark" style="margin-top:5px" v-if="activity.remark">
                  <span style="margin-right:5px">备注:</span>
                  <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 报销新增按钮 -->

      <!-- 项目结算申请新增按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormClearAdd1' && addSettlementForm.is_draft!='1'"
        @click="handleAddSettlementSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormClearAdd1' && addSettlementForm.is_draft!='1'"
        @click="handleAddSettlementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 项目结算申请编辑按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormClearAdd1' && addSettlementForm.is_draft=='1' && !draftDisable"
        @click="handleEditSettlementSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormClearAdd1' && addSettlementForm.is_draft=='1' && !draftDisable"
        @click="handleEditSettlementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 项目结算申请重新提交按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormClearHandle1' && addSettlementForm.is_edit=='1'"
        @click="getDialogVisible(false)"
      >取 消</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormClearHandle1' && addSettlementForm.is_edit=='1'"
        @click="handleEditSettlementSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>

      <!-- 签名组件 -->
    </div>
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 弹窗--审批 -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia"
      :before-close="approveVisibleClose"
      append-to-body
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addSettlementForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addSettlementForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addSettlementForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择" clearable>
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addSettlementForm.stage_selectArry"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addSettlementForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addSettlementForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="handleFinnaceApproval('-1','settlement',addSettlementForm.id)"
          :disabled="disableLimit"
          v-if="addSettlementForm.approval_status=='1'"
          style="background:#f4a029;"
          class="search"
        >驳回</el-button>
        <el-button
          @click="handleFinnaceApproval('1','settlement',addSettlementForm.id)"
          :disabled="disableLimit"
          v-if="addSettlementForm.approval_status=='1'"
          class="creat"
          style="background-color:#40A0F2;"
        >通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

import TableJson from '../../TableJson'
import UploadFile from '../../../components/UploadFile'
import SignDialog from '../../../components/SignDialog'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      approveVisible: false,
      noProjectWarningVis: false,
      sign_pic: '',
      receiverSignFlag: false,
      // 禁用按钮防抖
      disableLimit: false,

      imgList: [],
      detailsImgList: [],
      k_code: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',

      tiemID1: null,
      timeDou: 100,
      // 新增项目结算申请
      addSettlementForm: {
        money: 0,
        is_special: '0',
        special_money: 0,
        money_json: [],
        project_list: [],
        total: '',
        remark: '',
        annex: '',
        project_id: [],
      },

      approvalRemark: '',
      sendData: {
        number: '',
        pte_name: '',
        contract_money: '',
        settlement_show: '',
      },
      // 自动审批大通
      is_chase: '0',
      rules: {
        preset_member: [
          { required: true, message: '请选择预设审批人', trigger: 'change' },
        ],
      },
    }
  },
  async activated() {},
  async mounted() {},
  props: [],
  components: {
    UploadFile,
    SignDialog,
    TableJson,
  },
  watch: {
    '$store.state.process.finance.formData'(newval, olval) {
      this.addSettlementForm = newval
    },
    '$store.state.process.finance.dialogVisible'(newval, olval) {
      if (newval == false) {
        this.is_chase = '0'
      }
    },
    'addSettlementForm.annex': {
      handler: function (val, oldVal) {
        this.imgList = val
        this.detailsImgList = val
      },
    },
    // 默认驳回节点是当前节点
    'addSettlementForm.stage_selectArry': {
      handler: function (val, oldVal) {
        if (val && val.length > 0) {
          this.k_code = val[val.length - 1].id
        } else {
          this.k_code = ''
        }
      },
    },
    // 'addSettlementForm.is_special': {
    //   handler: function (val, oldVal) {
    //     if (val == '0') {
    //       this.addSettlementForm.special_money = 0
    //     }
    //   },
    // },
  },
  methods: {
    ...mapMutations('process/finance', ['getDialogVisible', 'getselectVis']),
    projectFilter(query = '') {
      let arr = this.projectList1.filter((item) => {
        return (
          item.project_id.includes(query) || item.project_show.includes(query)
        )
      })
      console.log('arr', arr)
      if (arr.length == 0) {
        this.$forceUpdate()
      }
      if (arr.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectList1Sub',
          arr.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit('process/finance/setprojectList1Sub', arr)
      }
    },
    handleProjectSelectBlur1(val) {
      if (!val) {
        if (this.projectList1.length > this.moreNum) {
          this.$store.commit(
            'process/finance/setprojectList1Sub',
            this.projectList1.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/finance/setprojectList1Sub',
            this.projectList1
          )
        }
        console.log('this.projectList1Sub', this.projectList1Sub)
      }
    },

    handleHiddenWarningBox() {
      this.noProjectWarningVis = false
    },
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},

    handleJsonChange1(data) {
      console.log('data', data)
      this.addSettlementForm.money_json = data
    },
    jiesuanChangeClick() {
      if (this.addArrivalForm.is_settle == '1') {
        this.addArrivalForm.is_settlement = '1'
      }
    },

    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      console.log('items', items)
      // this.$router.resolve({
      //   path: '/project/details/task',
      //   query: {
      //     project_id: items.project_id,
      //     project_name: items.project_name,
      //     isEdit: '1',
      //   },
      // })
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    upLoadChange(data) {
      this.imgList = data
    },
    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *撤回
    async handleFinnaceWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('is_chase', this.is_chase)

      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      // 清空驳回节点
      this.k_code = ''
      this.sign_pic = ''
      this.approvalRemark = ''
      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
      this.approveVisible = false
    },

    // *编辑项目结算申请提交
    async handleEditSettlementSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        // 判断是不是草稿
        if (this.addSettlementForm.is_draft == '1') {
          this.$refs.addSettlementForm1.validate(async (valid) => {})
        } else {
          this.$refs.addSettlementForm2.validate(async (valid) => {})
        }
      }
      if (
        this.addSettlementForm.preset_member == 'undefined' ||
        this.addSettlementForm.preset_member == undefined
      )
        this.addSettlementForm.preset_member = ''
      this.disableLimit = true
      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('finance_id', this.addSettlementForm.id)

        param.append('preset_member', this.addSettlementForm.preset_member)

        param.append('type', '2')
        param.append('business_name', this.addSettlementForm.business_name)
        param.append('total', this.addSettlementForm.total)

        param.append('remark', this.addSettlementForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        // // 单选
        // if (
        //   Array.isArray(this.addSettlementForm.isOld_project_id) &&
        //   !this.addSettlementForm.project_id
        // ) {
        //   param.append(
        //     'project_id',
        //     this.addSettlementForm.isOld_project_id.join(',')
        //   )
        // } else {
        //   param.append('project_id', this.addSettlementForm.project_id)
        // }
        // 多选
        // param.append('project_id', this.addSettlementForm.project_id.join(','))
        // if (this.$store.state.process.finance.isFromProjectBar) {
        //   param.append(
        //     'project_id',
        //     this.$store.state.process.finance.projectId
        //   )
        // } else {
        //   param.append(
        //     'project_id',
        //     this.addSettlementForm.project_id.join(',')
        //   )
        // }

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/settlement_edit',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
        this.getselectVis(false)
      }, this.timeDou)
    },
    // *项目结算申请新增点击提交
    async handleAddSettlementSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        this.$refs.addSettlementForm1.validate(async (valid) => {
          //   如果校验失败
          // if (valid == false) return this.$message.error('角色信息不合规')
          // 如果校验成功
        })
      }

      this.disableLimit = true
      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('preset_member', this.addSettlementForm.preset_member)

        param.append('type', '2')
        param.append('business_name', this.addSettlementForm.business_name)
        param.append('total', this.addSettlementForm.total)

        param.append('remark', this.addSettlementForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        // 多选
        // param.append('project_id', this.addSettlementForm.project_id.join(','))
        // // 单选
        // param.append('project_id', this.addSettlementForm.project_id)
        // if (this.$store.state.process.finance.isFromProjectBar) {
        //   param.append(
        //     'project_id',
        //     this.$store.state.process.finance.projectId
        //   )
        // } else {
        //   param.append(
        //     'project_id',
        //     this.addSettlementForm.project_id.join(',')
        //   )
        // }

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/settlement_add',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
        this.getselectVis(false)
      }, this.timeDou)
    },

    getList() {
      if (this.$store.state.process.finance.isFromProjectBar) {
        this.$store.commit(
          'process/finance/getSettlementList',
          this.$store.state.process.finance.projectId
        )
        this.$store.commit(
          'process/finance/getFinanceSildeBarNum',
          this.$store.state.process.finance.projectId
        )
      } else {
        this.$store.commit('process/finance/getSettlementList')
      }
    },

    // 选择项目名称1
    async handleProjectSelectChange1(val) {
      if (val && val.length > 1) {
        this.$message.error('关联项目只能选择1个')
        this.addSettlementForm.project_id = [val[0]]
      }
      this.sendData = {
        number: '',
        pte_name: '',
        contract_money: '',
        settlement_show: '',
      }
      // *、实时请求到账金额
      if (this.addSettlementForm.project_id.length <= 0) {
        // this.sendNumber = ''
        this.sendData.number = ''
      }
      if (
        (this.showForm == 'showFormClearAdd1' ||
          this.showForm == 'showFormClearHandle1') &&
        this.addSettlementForm.project_id.length > 0
      ) {
        let paramss = new FormData()
        paramss.append('member_id', this.member_id)
        paramss.append('token', this.token)
        paramss.append('cache_department_id', this.cache_department_id)
        paramss.append('company_id', this.company_id)

        paramss.append(
          'project_id',
          `[${this.addSettlementForm.project_id.join(',')}]`
        )

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_arrival_by_project_id',
          data: paramss,
        }).then((results) => {
          if (results.data.code != 200)
            return this.$message.error(results.data.datas.msg)
          // this.sendNumber = results.data.datas.arrival
          this.sendData.number = results.data.datas.arrival
        })
      }
      // *、实时请求到账金额

      // *、实时请求项目结算
      if (this.addSettlementForm.project_id.length <= 0) {
        this.sendData.number = ''
      }
      if (
        (this.showForm == 'showFormClearAdd1' ||
          this.showForm == 'showFormClearHandle1') &&
        this.addSettlementForm.project_id.length > 0
      ) {
        let paramss = new FormData()
        paramss.append('member_id', this.member_id)
        paramss.append('token', this.token)
        paramss.append('cache_department_id', this.cache_department_id)
        paramss.append('company_id', this.company_id)

        paramss.append('project_id', this.addSettlementForm.project_id[0])

        this.$axios({
          method: 'post',
          url: '/api/Finance/settlement_by_project_id',
          data: paramss,
        }).then((results) => {
          if (results.data.code != 200) {
            this.addSettlementForm.project_id = []
            return this.$message.error(results.data.datas.msg)
          }

          this.addSettlementForm.money = results.data.datas.info.money
          this.sendData.pte_name = results.data.datas.info.pte_name
          this.sendData.contract_money = results.data.datas.info.contract_money
          this.sendData.settlement_show =
            results.data.datas.info.settlement_show
        })
      }
      // *、实时请求项目结算

      // 项目财务实时请求
      if (this.$store.state.process.finance.isFromProjectBar) {
        let paramss = new FormData()
        paramss.append('member_id', this.member_id)
        paramss.append('token', this.token)
        paramss.append('cache_department_id', this.cache_department_id)
        paramss.append('company_id', this.company_id)

        paramss.append(
          'project_id',
          this.$store.state.process.finance.projectId
        )

        this.$axios({
          method: 'post',
          url: '/api/Finance/settlement_by_project_id',
          data: paramss,
        }).then((results) => {
          if (results.data.code != 200) {
            this.addSettlementForm.project_id = []
            return this.$message.error(results.data.datas.msg)
          }

          this.addSettlementForm.money = results.data.datas.info.money
          this.sendData.pte_name = results.data.datas.info.pte_name
          this.sendData.contract_money = results.data.datas.info.contract_money
          this.sendData.settlement_show =
            results.data.datas.info.settlement_show
        })
      }
      if (this.$store.state.process.finance.isFromProjectBar) {
        this.sendData.number = ''
        let paramss = new FormData()
        paramss.append('member_id', this.member_id)
        paramss.append('token', this.token)
        paramss.append('cache_department_id', this.cache_department_id)
        paramss.append('company_id', this.company_id)

        paramss.append(
          'project_id',
          `[${this.$store.state.process.finance.projectId}]`
        )

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_arrival_by_project_id',
          data: paramss,
        }).then((results) => {
          if (results.data.code != 200)
            return this.$message.error(results.data.datas.msg)
          // this.sendNumber = results.data.datas.arrival
          this.sendData.number = results.data.datas.arrival
        })
      }
      // 强制刷新组件
      this.$forceUpdate()
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },
  },

  async created() {
    this.sendData = {
      number: '',
      pte_name: '',
      contract_money: '',
      settlement_show: '',
    }

    this.addSettlementForm = JSON.parse(
      JSON.stringify(this.$store.state.process.finance.formData)
    )
    if (this.addSettlementForm.annex) {
      this.imgList = this.addSettlementForm.annex
      this.detailsImgList = this.addSettlementForm.annex
    }
    this.disableLimit = false
    console.log('this.getProjectListAsync.type', this.$route.query.type)
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    // this.handleProjectSelectChange1()
  },
  computed: {
    ...mapState('process/finance', [
      'showForm',
      'draftDisable',
      'formData',
      'moreNum',
      'projectList1',
      'projectList1Sub',
    ]),
    sumMoneyForEnd() {
      return (
        this.addSettlementForm.money * 1.0 +
        this.addSettlementForm.special_money * 1.0
      ).toFixed(2)
    },
  },
}
</script>
<style lang="less" scoped>
@import url(../../../views/topBar/finance.scss);
.search-keyword-more {
  width: 100%;
  text-align: center;

  font-size: 14px;
  color: #999;
}
.noProjectWarning {
  cursor: pointer;
}
.noProjectWarning:hover {
  color: #128bf1;
}
.noProjectWarningBox:hover .closeIcon {
  display: block;
}
.noProjectWarningBox {
  position: absolute;
  left: 180px;
  top: -10px;
  .closeIcon {
    display: none;
    position: absolute;
    font-size: 16px;
    z-index: 3;
    top: 10px;
    cursor: pointer;
    right: 5px;
  }
  .closeIcon:hover {
    color: #128bf1;
  }
  .arrow {
    position: absolute;
    left: -5px;
    top: 15px;
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
    border: 1px solid #ccc;
    border-right: none;
    border-top: none;
    background-color: #fff;
    z-index: 2;
  }
  .container {
    position: relative;
    z-index: 1;
    width: 280px;
    padding: 20px;
    padding-right: 20px;
    border: 1px solid #ccc;
    background-color: #fff;
  }
}
</style>